import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '../../services/translate/translate.service';

@Pipe({
  name: 'ibexDate'
})
export class IbexDatePipe extends DatePipe implements PipeTransform {

  private dateFormatMap = new Map<string, string>([
    ['eventDate', 'dd. LLLL - HH:mm'],
    ['medium', 'dd.MM.YY - HH:mm'],
    ['mediumLong', 'dd.MM.yyyy, HH:mm'],
    ['shortDate', 'dd.MM.yy'],
    ['mediumDate', 'dd.MM.yyyy'],
    ['longDateShortMonth', 'EEEE, d. MMM'],
    ['longDate', 'EEEE, d. MMMM'],
    ['fullDate', 'EEEE, d. MMMM yyyy'],
    ['dayMonth', 'd. MMMM'],
    ['time', 'HH:mm'],
    ['weekday', 'EEEE'],
    ['weekdayShort', 'EE'],
    ['month', 'MMMM'],
    ['monthShort', 'MMM'],
    ['year', 'YYYY'],
    ['day', 'd'],
    ['dayMonthYear', 'd. MMMM yyyy'],
    ['full', 'EEEE, dd.MM.yyyy'],
    ['fullWithTime', 'EEEE, dd.MM.yyyy - HH:mm']
  ]);

  constructor(private translate: TranslateService) {
    super(translate.getCurrentLocale());
  }

  transform(value: Date | string | number | null | undefined | any, format = 'mediumDate'): any {
    if (!value || value.toString() === 'Invalid Date') {
      return null;
    }
    if ((typeof value === 'string' || typeof value === 'number') && /^\d+$/.test(value.toString())) { // detects timestamp and checks if unix-timestamp
      value = Number.parseInt(value.toString(), 10) as any;
      if (value <= Date.now() + (100 * 365 * 24 * 3600) && (Date.now() + (100 * 365 * 24 * 3600)).toString().length - value.toString().length >= 2) {
        value = (value as number) * 1000;
      }
    }
    let result = super.transform(value, this.dateFormatMap.get(format) ? this.dateFormatMap.get(format) : format, undefined, this.translate.getCurrentLocale());
    if (result.endsWith('.')) {
      result = result.slice(0, -1);
    }
    if (format === 'year') {
      const d = new Date(value);
      if (result !== d.getFullYear().toString()) {
        return d.getFullYear().toString();
      }
    }
    return result;
  }

}
